export const cEstadoFisico =
    {
           EnTransitoProveedor:50,
           Recepcionado:51,
           UbicadoEnBodega:52,
           PendienteTrasladoFisico:53,
           EnTransitoBodegas:54,
           PendienteEntregaCliente:55,
           EnTransitoCliente:56,
           EntregadoCliente:57,
           RecibidoDevolución:58,
};

